module.exports = __webpack_public_path__ + "static/offices-tile-image@2x-10ce88fe7b85b2b6d69c785aa6729904.jpg";